import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { shopApi, errText } from "@/lib/shopAuth";
import ShopLayout from "./ShopLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ShopReset() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await shopApi.post("/shop/auth/reset-password", { token: sp.get("token"), password });
      toast.success(data.message); navigate("/sklep/logowanie");
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  return (
    <ShopLayout>
      <div className="mx-auto max-w-md px-4 py-16" data-testid="shop-reset">
        <h1 className="font-display text-2xl font-bold uppercase mb-5">Ustaw nowe hasło</h1>
        <Label className="text-xs">Nowe hasło (min. 6 znaków)</Label>
        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 bg-white/5 border-white/10 text-neutral-100" />
        <Button onClick={submit} disabled={busy} className="mt-4 w-full h-11 bg-amber-400 text-[#0D1117] font-bold uppercase">{busy ? "…" : "Zapisz hasło"}</Button>
      </div>
    </ShopLayout>
  );
}
